import React from 'react'
import { IProps } from './Interface'
import { Box, useTheme, useMediaQuery, Grid, Typography } from '@material-ui/core'
import useStyles from './Styles'
import classNames from 'classnames/bind'
import { AvatarSelect } from 'components/avatar-select'

const BasicsPageDisplay: React.FC<IProps> = ({
  hometownLocation,
  currentRole,
  currentCompany,
  schools,
  firstName,
  lastName,
  avatar
}) => {
  const theme = useTheme()
  const classes = useStyles({})
  const cx = classNames.bind(classes)
  const downMD = useMediaQuery(theme.breakpoints.down('md'))
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Grid container className={classes.root} direction={downSM ? 'column-reverse' : downMD ? 'row-reverse' : 'row'}>
      <Grid
        md={8}
        className={cx({
          infoContainer: true,
          infoContainerMobile: downSM || downMD
        })}
      >
        {hometownLocation && (
          <Box className={classes.row}>
            <Typography id="hometown-location-label">My hometown is</Typography>
            <Typography className={classes.hometown} id="hometown-location-answer">
              {hometownLocation.state ? `${hometownLocation.city}, ${hometownLocation.state}` : hometownLocation.city}
            </Typography>
          </Box>
        )}

        {currentRole && (
          <Box className={classes.row}>
            <Typography id="current-role-label">Currently working as</Typography>
            <Typography id="current-role-answer">{currentRole}</Typography>
          </Box>
        )}

        {currentCompany && (
          <Box className={classes.row}>
            <Typography id="current-company-label">for the company</Typography>
            <Typography id="current-company-answer" style={{ color: theme.palette.common.lightPurple }}>
              {currentCompany}
            </Typography>
          </Box>
        )}

        <Box className={classes.schoolContainer}>
          {schools.map((school, index) => (
            <Box key={index} className={classes.schoolRoot}>
              {school.schoolName && (
                <Box className={classes.row}>
                  <Typography id="school-label">School</Typography>
                  <Typography id="school-answer" className={classes.schoolLabel}>
                    {school.schoolName}
                  </Typography>
                </Box>
              )}

              {school.gradYear && (
                <Box className={classes.row}>
                  <Typography id="graduate-year-label">Graduate year</Typography>
                  <Typography id="graduate-year-answer" className={classes.schoolLabel}>
                    {school.gradYear}
                  </Typography>
                </Box>
              )}

              {school.degreeType && (
                <Box className={classes.row}>
                  <Typography id="degree-type-label">My degree is a</Typography>
                  <Typography id="degree-type-answer" className={classes.schoolLabel}>
                    {school.degreeType}
                  </Typography>
                </Box>
              )}

              {school.fieldOfStudy && (
                <Box className={classes.row}>
                  <Typography id="field-of-study-label">In the field of</Typography>
                  <Typography id="field-of-study-answer" className={classes.schoolLabel}>
                    {school.fieldOfStudy}
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid direction="column" md={4}>
        <Grid className={classes.userNameContainer}>
          <Typography id="user-name" className={classes.userName}>
            {firstName} {lastName}
          </Typography>
        </Grid>
        <AvatarSelect
          user={{
            firstName,
            lastName,
            avatar
          }}
          disabled={true}
        />
      </Grid>
    </Grid>
  )
}

BasicsPageDisplay.defaultProps = {
  schools: []
}

export default (props: IProps) => <BasicsPageDisplay {...props} />
